const turnstileConfig = {
  siteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY,
  scriptUrl: 'https://challenges.cloudflare.com/turnstile/v0/api.js',
  scriptSelector: 'script[src*="challenges.cloudflare.com/turnstile"]',
};

export default turnstileConfig;
